(function ($, _, undefined) {
    $.fn.jumpList = function (options) {
        var DATA_KEY = 'jumpListState',
            dataSourceUrl = options.dataSource,
            maxRetries = _.isNumber(options.maxRetries) ? options.maxRetries : 3;

        if (_.isFunction(options.change)) {
            this.change(options.change);
        }

        if (dataSourceUrl) {
            this.focus(function () {
                var $jumpListCtrl = $(this),
                    state = getState.call($jumpListCtrl);

                state.shouldFetch = !state.allFetched && state.currentRetry <= maxRetries;
                if (state.shouldFetch) {
                    fetchPages.call($jumpListCtrl, true);
                }
            });

            this.blur(function () {
                var $jumpListCtrl = $(this),
                    state = getState.call($jumpListCtrl);

                state.shouldFetch = false;
            });
        }

        function getState() {
            var $jumpListCtrl = this,
                state = $jumpListCtrl.data(DATA_KEY);

            if (state == null) {
                state = {
                    currentPage: _.isFinite(options.startPage) ? Math.max(0, options.startPage) : 0,
                    currentRetry: 0,
                    shouldFetch: false,
                    fetching: false,
                    allFetched: false,
                    loadingIndicator: $('<option>', {
                        text: options.loadingText,
                        disabled: 'disabled'
                    })
                };

                $jumpListCtrl.data(DATA_KEY, state);
            }

            return state;
        }

        function fetchPages(showLoadingIndicator) {
            var $jumpListCtrl = this,
                state = getState.call($jumpListCtrl),
                url;

            if (state.shouldFetch && !state.fetching) {
                state.fetching = true;
                if (showLoadingIndicator) {
                    $jumpListCtrl.append(state.loadingIndicator);
                }

                url = $.advertiser.setUrlParameter('pageNumber', state.currentPage, dataSourceUrl);
                $.advertiser.ajaxPost({
                    url: url,
                    ignoreBeforeAjax: true,
                    onSuccess: function (data) {
                        if (data && !data.Errors) {
                            state.fetching = false;
                            state.currentRetry = 0;
                            state.currentPage++;
                            if (data.length > 0) {
                                $.each(data, function (index, item) {
                                    $('<option>', {
                                        text: item.Text,
                                        val: item.Value
                                    }).insertBefore(state.loadingIndicator);
                                });

                                fetchPages.call($jumpListCtrl);
                            } else {
                                state.allFetched = true;
                                state.loadingIndicator.remove();
                            }
                        } else {
                            // includes JSON error cases
                            onError();
                        }
                    },
                    onJsonError: _.noop,
                    onAjaxError: onError
                });
            } else if (!showLoadingIndicator) {
                state.loadingIndicator.remove();
            }

            function onError() {
                state.fetching = false;
                state.currentRetry++;
                if (state.currentRetry <= maxRetries) {
                    fetchPages.call($jumpListCtrl);
                } else {
                    // NOTE: leave the loading indicator in place, to signal the failure of loading all the data
                }
            }
        }
    };
})(jQuery, _);
